import { FC } from 'react';
import Cookies from 'universal-cookie';
import * as jwt from 'jsonwebtoken';
import rules, { Plan, Role, Rules, computeRulesArray, UserAddOn } from './rules';
import { JWT_COOKIE_KEY } from '../../../consts';
import { shouldLogoutForExpiredSession } from '../../../utils/offlineSyncGate';

const check = (
  rules: Rules,
  roles: Role[],
  action: string,
  data: any,
  plan: Plan,
  landingPage: boolean,
  userAddOns: UserAddOn[] | undefined,
  logout: Function | undefined
): boolean => {
  const permissions = computeRulesArray(plan, roles, userAddOns);

  if (!permissions.static.length) {
    // none of the roles is not present in the rules
    return false;
  }

  const getCookies = new Cookies();
  const token = getCookies.get(`${JWT_COOKIE_KEY}`);
  const tokenSet = getCookies.get(`${JWT_COOKIE_KEY}_SET`);
  const decodedJWT: any = jwt.decode(token);
  const tokenExpValid = decodedJWT && decodedJWT.exp ? Date.now() / 1000 < decodedJWT.exp : false;
  const online = typeof navigator === 'undefined' ? true : navigator.onLine;
  if (shouldLogoutForExpiredSession(online, landingPage, tokenExpValid, !!token)) {
    if (!tokenExpValid && tokenSet) {
      console.warn('Session expired.');
      getCookies.remove(`${JWT_COOKIE_KEY}_SET`, { path: '/' });
      if (!!token) alert('Session expired, please login again.');
    }
    if (!!token && logout) logout();
    return false;
  }
  const staticPermissions = permissions.static;

  if (staticPermissions && staticPermissions.includes(action)) {
    // static rule not provided for action
    return true;
  }

  const dynamicPermissions = permissions.dynamic;

  if (dynamicPermissions) {
    const permissionCondition = dynamicPermissions[action];
    if (!permissionCondition) {
      // dynamic rule not provided for action
      return false;
    }

    return permissionCondition(data);
  }
  return false;
};

type Props = {
  yes: Function;
  no: Function;
  roles: Role[];
  action: string;
  userAddOns?: UserAddOn[];
  data?: any;
  plan: Plan;
  landingPage: boolean;
  logout?: Function;
  navItemCheck?: boolean;
};

const Can: FC<Props> = props => {
  const { yes, no, roles, action, data, plan, landingPage, userAddOns, logout, navItemCheck } = props;
  const result: boolean = check(rules, roles, action, data, plan, landingPage, userAddOns, logout);

  if (navItemCheck) {
    return navItemCheck ? yes() : no();
  } else {
    return result && navItemCheck === undefined ? yes() : no();
  }
};

export const canPerformAction: (props: any) => boolean = props => {
  const { roles, action, data, plan, landingPage, userAddOns } = props;
  return check(rules, roles, action, data, plan, landingPage, userAddOns, undefined);
};

Can.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default Can;
